import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';
import {
  paramsToObject,
} from '@tracking/components/utils';

function getClientId() {
  const allTrackers = window.ga && window.ga.getAll ? window.ga.getAll() : null;
  if (allTrackers && allTrackers.length) {
    const tracker = allTrackers[0];
    if (tracker) {
      return tracker.get('clientId');
    }
  }

  return undefined;
}

function pageViewFormatter({ location, ...rest }) {
  const urlParams = new URLSearchParams(location.search);
  const entries = urlParams.entries();
  const params = paramsToObject(entries);
  const clientId = getClientId();
  // custom event to trigger once pageViewFormatted is called
  window.dispatchEvent(new CustomEvent('tracking_initialized'));
  return getGTMEventData(EVENT_NAMES.PAGE_LOAD, 'load', {
    ...params, client_id: clientId, ...rest,
  });
}

export default pageViewFormatter;
